<template>
  <v-card class="pa-4">
    <div class="d-flex justify-end mb-3">
      <v-btn :loading="loading" depressed dark color="primary" @click="() => $refs['popup-update'].openDialog()">
        Cập nhật điểm danh
      </v-btn>
    </div>
    <StudentTable :key="itemsChangeKey" />
    <PopupUpdate ref="popup-update" />
  </v-card>
</template>
<script>
import StudentTable from './StudentTable.vue'
import PopupUpdate from './PopupUpdate.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: { StudentTable, PopupUpdate },
  data: () => ({ loading: false }),
  methods: { ...mapActions({ fetchItems: 'boardingClassSessionAttendance/fetchItems' }) },
  computed: {
    ...mapGetters({
      itemsChangeKey: 'boardingClassSessionAttendance/itemsChangeKey',
    }),
  },
  async mounted() {
    this.loading = true
    const items = await this.fetchItems({ _sort: 'nameToNumber:ASC', boardingClassSession: this.$route.params.id })
    if (items.some(i => i.status === 'none')) {
      this.$refs['popup-update'].openDialog(true)
    }
    this.loading = false
  },
}
</script>